import { trueDaysForm, trueHoursForm, trueMinutesForm2, trueSecondsForm2 } from "./true.word.form";

export const unixToShortString = (timestamp: number) => {
    if (!timestamp)
        return "";
    
    const date = new Date(timestamp * 1000);
    const dateTimeFormat = new Intl.DateTimeFormat('ru', { year: 'numeric', month: '2-digit', day: '2-digit' }) 
    const [{ value: day },,{ value: month },,{ value: year }] = dateTimeFormat.formatToParts(date) 
    
    return  day + "." + month + "." + year;
}

export const unixToString = (timestamp: number) => {
    if (!timestamp)
        return "";

    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}.${month} ${hours}:${minutes}`;
}

export const unixToDrawString = (timestamp: number) => {
    if (!timestamp)
        return "";

    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    
    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export const getTimeLeft = (operTime: number, sign: number = 1): string => {
    const currentTime = now();
    const timeDiff = sign === 1 ? currentTime - operTime : operTime - currentTime;

    if (timeDiff < 60) {
        const seconds = Math.floor(timeDiff);
        return `${seconds} ${trueSecondsForm2(seconds)}`;
    } else if (timeDiff < 3600) {
        const minutes = Math.floor(timeDiff / 60);
        return `${minutes} ${trueMinutesForm2(minutes)}`;
    } else if (timeDiff < 86400) {
        const hours = Math.floor(timeDiff / 3600);
        return `${hours} ${trueHoursForm(hours)}`;
    }
    else {
        const days = Math.floor(timeDiff / 86400);
        return `${days} ${trueDaysForm(days)}`;
    }
}

export const getTimeLeftDetail = (operTime: number, sign: number = 1, detail: 1 | 2 = 1): string => {
    const currentTime = now();
    const timeDiff = sign === 1 ? currentTime - operTime : operTime - currentTime;

    if (timeDiff < 60) {
        const seconds = Math.floor(timeDiff);
        return `${seconds} ${trueSecondsForm2(seconds)}`;
    }

    const days = Math.floor(timeDiff / 86400);
    const hours = Math.floor((timeDiff % 86400) / 3600);
    const minutes = Math.floor((timeDiff % 3600) / 60);
    const seconds = Math.floor(timeDiff % 60);

    if (detail === 1) {
        if (days > 0) return `${days} ${trueDaysForm(days)}`;
        if (hours > 0) return `${hours} ${trueHoursForm(hours)}`;
        return `${minutes} ${trueMinutesForm2(minutes)}`;
    } else {
        if (days > 0) return `${days} д. ${hours} ч.`;
        if (hours > 0) return `${hours} ч. ${minutes} м.`;
        return `${minutes} м. ${seconds} с.`;
    }
}

export const formatTimePeriod = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hours > 0) parts.push(hours === 1 ? '1 час' : `${hours} ч.`);
    if (minutes > 0) parts.push(`${minutes} мин.`);
    if (secs > 0 || !parts.length) parts.push(`${secs} сек.`);

    return parts.join(' ');
}

export const now = () => Math.round(new Date().getTime() * 0.001);
